/**
 * Build a nested tree of subcategories under a category (same structure as admin CategoryManagement).
 * @param {Array<object>} flatList - items from GET .../subcategories (items array)
 * @param {string} categoryIdStr
 */
function pickSubId(row) {
  return String(row?.subCategoryId?._id ?? row?.subCategoryId ?? row?._id ?? row?.id ?? "").trim();
}

function pickParentSubId(row) {
  return String(row?.parentSubCategoryId?._id ?? row?.parentSubCategoryId ?? "").trim();
}

export function buildSubcategoryTree(flatList, categoryIdStr) {
  const cid = String(categoryIdStr || "");
  if (!cid || !Array.isArray(flatList)) return [];

  const normalized = flatList
    .map((sub) => {
      const rowCat = String(sub.categoryId?._id ?? sub.categoryId ?? "").trim();
      if (rowCat && rowCat !== cid) return null;
      const uiId = pickSubId(sub);
      if (!uiId) return null;
      const parentId = pickParentSubId(sub);
      return {
        ...sub,
        uiId,
        name: String(sub.subCategoryName ?? sub.name ?? "Unnamed").trim() || "Unnamed",
        level: Math.max(2, Math.min(5, Number(sub.level || 2))),
        parentSubCategoryId: parentId || null,
      };
    })
    .filter(Boolean);

  const byParent = new Map();
  normalized.forEach((sub) => {
    const parentKey = sub.parentSubCategoryId ? String(sub.parentSubCategoryId) : "root";
    if (!byParent.has(parentKey)) byParent.set(parentKey, []);
    byParent.get(parentKey).push(sub);
  });

  const walk = (parentKey = "root", depth = 0) => {
    const list = byParent.get(parentKey) || [];
    return list
      .sort((a, b) => a.name.localeCompare(b.name))
      .map((item) => ({
        ...item,
        treeDepth: depth,
        children: walk(String(item.uiId), depth + 1),
      }));
  };

  return walk("root", 0);
}

export function countSubRowsInTree(rows = []) {
  let n = 0;
  const walk = (list) => {
    list.forEach((sub) => {
      n += 1;
      if (Array.isArray(sub.children) && sub.children.length) walk(sub.children);
    });
  };
  walk(rows);
  return n;
}
